/**
 * Model representing the response of InstalledBasicProducts API
 */
export default class InstalledBasicProducts {
  /**
   * @param {{
   *   installedPrimaryProduct: {
   *     installedFunctionValue: ?({
   *       name: string,
   *       value: string,
   *       type: string,
   *     }[]),
   *     productSpecification: {
   *       id: { system: string, namespace: string, id: string }[],
   *       name: string,
   *       type: string,
   *       description: string,
   *       extendedName: string,
   *     },
   *     installationAddress: ?{
   *       addressLine1: string,
   *       street: string,
   *       streetNumber: string,
   *       city: string,
   *       zip: string,
   *       latitude: ?string,
   *       longitude: ?string,
   *     },
   *   },
   *   installedDevice: {
   *     productSpecification: {
   *       id: { system: string, namespace: string, id: string }[],
   *       name: ?string,
   *     },
   *   },
   *   installedContract: {
   *     hasTariff: ?({
   *       price: { amount: number, currency: string },
   *       tariffSpecification: {
   *         id: { system: string, namespace: string, id: string }[],
   *         recurrenceType: string,
   *         vatRate: number,
   *       },
   *     }[]),
   *     contractSpecification: {
   *       id: {system: string, namespace: string, id: string}[],
   *     },
   *   },
   * }} data
   */
  constructor(data) {
    this._data = data;
  }

  /**
   * Address of customers installed internet connection. Only specified for internet SNs.
   *
   * @return {?{
   *   street: string,
   *   streetNumber: string,
   *   city: string,
   *   postCode: string,
   * }}
   */
  get installationAddress() {
    const { installationAddress } = this._data.installedPrimaryProduct;
    return installationAddress
      ? {
          street: installationAddress.street,
          streetNumber: installationAddress.streetNumber,
          city: installationAddress.city,
          postCode: installationAddress.zip,
        }
      : null;
  }

  /**
   * Model name of the last device obtained with tariff, if customer bought any.
   *
   * @return {?string}
   */
  get installedDeviceName() {
    return this._data.installedDevice.productSpecification?.name ?? null;
  }
}
